const MINTER_ROLE = 2n;
const UINT32_MAX = 4294967295;
const NULL_ADDRESS = "0x0000000000000000000000000000000000000000";
const NON_NULL_ADDRESS = "0x0000000000000000000000000000000000000001";
const NULL_BYTES32 = "0x0000000000000000000000000000000000000000000000000000000000000000";
const MINT_GAS_LIMIT_MULTIPLIER = 1.2;
const MINT_FALLBACK_GAS_LIMIT = 200000n;
const ContractErrorName = {
  // SoundEdition
  MetadataIsFrozen: "MetadataIsFrozen",
  InvalidRoyaltyBPS: "InvalidRoyaltyBPS",
  InvalidRandomnessLock: "InvalidRandomnessLock",
  ExceedsEditionAvailableSupply: "ExceedsEditionAvailableSupply",
  InvalidAmount: "InvalidAmount",
  InvalidFundingRecipient: "InvalidFundingRecipient",
  InvalidEditionMaxMintableRange: "InvalidEditionMaxMintableRange",
  MaximumHasAlreadyBeenReached: "MaximumHasAlreadyBeenReached",
  ExceedsAddressBatchMintLimit: "ExceedsAddressBatchMintLimit",
  MintRandomnessAlreadyRevealed: "MintRandomnessAlreadyRevealed",
  NoAddressesToAirdrop: "NoAddressesToAirdrop",
  MintHasConcluded: "MintHasConcluded",
  MintsAlreadyExist: "MintsAlreadyExist",
  // IMinterModule
  Underpaid: "Underpaid",
  ExceedsAvailableSupply: "ExceedsAvailableSupply",
  MintNotOpen: "MintNotOpen",
  MintPaused: "MintPaused",
  InvalidTimeRange: "InvalidTimeRange",
  Unauthorized: "Unauthorized",
  InvalidAffiliateFeeBPS: "InvalidAffiliateFeeBPS",
  FeeRegistryIsZeroAddress: "FeeRegistryIsZeroAddress",
  // Child minters
  InvalidMaxMintableRange: "InvalidMaxMintableRange",
  ExceedsMaxPerAccount: "ExceedsMaxPerAccount",
  MaxMintablePerAccountIsZero: "MaxMintablePerAccountIsZero",
  InvalidMerkleProof: "InvalidMerkleProof",
  MerkleRootHashIsEmpty: "MerkleRootHashIsEmpty"
};

export { ContractErrorName, MINTER_ROLE, MINT_FALLBACK_GAS_LIMIT, MINT_GAS_LIMIT_MULTIPLIER, NON_NULL_ADDRESS, NULL_ADDRESS, NULL_BYTES32, UINT32_MAX };
